import React from 'react';
import './InfoMessage.scss';
import { formatCurrency, formatDate, dateformatter } from "../../../utils/helpers";

/** @import {InfoMessageProps} from './InfoMessageTypes' */

function InfoMessage(/** @type {InfoMessageProps} */ {maturingAccount }) {
    return (
        <div className="infoMessage">
            <div className="pb_info_content">
                {/*<div className="iconWrapper">*/}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <path d="M11.999 8.53125C11.861 8.53125 11.749 8.64325 11.75 8.78125C11.75 8.91925 11.862 9.03125 12 9.03125C12.138 9.03125 12.25 8.91925 12.25 8.78125C12.25 8.64325 12.138 8.53125 11.999 8.53125" stroke="#1463AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 21.5312V21.5312C7.029 21.5312 3 17.5023 3 12.5312V12.5312C3 7.56025 7.029 3.53125 12 3.53125V3.53125C16.971 3.53125 21 7.56025 21 12.5312V12.5312C21 17.5023 16.971 21.5312 12 21.5312Z" stroke="#1463AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 12.5312V17.5312" stroke="#1463AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                {/*</div>*/}
                <div className="textContent">
                    <h4 className="infoTitle">How it works</h4>
                    <p className="infoBody">You'll receive our best available rate on <b>{new Date(maturingAccount == undefined ? 0 : (maturingAccount.maturity == undefined ? 0 : maturingAccount.maturity.maturityDate)).toLocaleDateString('en-US', { weekday: 'long' })} {dateformatter(maturingAccount == undefined ? '' : (maturingAccount.maturity == undefined ? '' : maturingAccount.maturity.maturityDate))}</b>, which might be our new customer rate or your renewal rate, depending on which one is higher. Renewal rates will never change, but the customer rates may go up or down.</p>
                </div>
            </div>
            </div>
    );
}

export default InfoMessage;